// src/components/CustomFields/fields/NumericIntegerField.tsx
// NumericIntegerField component migrated from legacy

import React from 'react';
import CustomFieldsService from '../../../api/CustomFieldsService';
import $ from 'jquery';
import InputNumber from 'rc-input-number';
import 'rc-input-number/assets/index.css';
import ClickOutSide from '../../Globals/ClickOutSide';
import CorgeeStorageHelper from '../../Globals/CorgeeStorageHelper';
import './NumericIntegerField.css';
import '../../../assets/fonts/glyphs/material-icons.css';
import type { BaseFieldProps, CustomFieldItem } from './types';

interface NumericIntegerFieldState {
  value: string | number;
  EditorEnabled: boolean;
  editableValue: string;
  disableAutoSave: boolean;
  previousWidth: number;
  customField: CustomFieldItem;
  canEdit: boolean;
  canEditR: boolean;
  apiConfig: { url: string; token: string };
  canEditOwner: boolean;
  isAdmin: boolean;
}

class NumericIntegerField extends React.Component<BaseFieldProps, NumericIntegerFieldState>
{
  private inputIntegerRef = React.createRef<any>();

  constructor(props: BaseFieldProps)
  {
    super(props);
    const cf = props.customField;

    this.state = {
      value: cf.Value === null || cf.Value === undefined ? '' : cf.Value,
      EditorEnabled: props.EditorEnabled || false,
      editableValue: '',
      disableAutoSave: props.disableAutoSave || false,
      previousWidth: 0,
      customField: cf,
      canEdit:
        (cf as any).SummatoryValuePhases === true
          ? false
          : props.canEdit && cf.ConversationIsEnable !== false,
      canEditR: CorgeeStorageHelper.canEdit(),
      apiConfig: props.apiConfig,
      canEditOwner: CorgeeStorageHelper.canEditOwner(
        props.conversation,
        CorgeeStorageHelper.personId(),
        true,
      ),
      isAdmin: CorgeeStorageHelper.isAdmin(),
    };

    this.handleChange = this.handleChange.bind(this);
    this.save = this.save.bind(this);
    this.enableEditor = this.enableEditor.bind(this);
    this.disableEditor = this.disableEditor.bind(this);
    this.onUpdateCustomField = this.onUpdateCustomField.bind(this);
    this.onOpenEditHistory = this.onOpenEditHistory.bind(this);
    this.onSaveModal = this.onSaveModal.bind(this);
    this.onUpdateModal = this.onUpdateModal.bind(this);
    this.isInteger = this.isInteger.bind(this);
    this.validateOwners = this.validateOwners.bind(this);
  }

  componentWillReceiveProps(nextProps: BaseFieldProps)
  {
    const cf = nextProps.customField;
    // Only update if the value actually changed to prevent infinite loops
    if (
      cf.Value !== this.state.customField.Value ||
      cf.CustomFieldValueId !== this.state.customField.CustomFieldValueId
    )
    {
      this.setState({
        customField: cf,
        value: cf.Value === null ? '' : cf.Value,
      });
    }
  }

  handleChange(inputValue: number | string)
  {
    this.setState({ value: inputValue });
  }

  validateOwners(
    event: React.MouseEvent,
    customField: CustomFieldItem,
    isAdmin: boolean,
    _canEditOwner: boolean,
  )
  {
    if (customField.Name !== 'Actual')
    {
      this.enableEditor(event);
    }
    else
    {
      if (isAdmin === true)
      {
        this.enableEditor(event);
      }
      else
      {
        this.disableEditor();
      }
    }
  }

  save()
  {
    const { value, editableValue, disableAutoSave } = this.state;

    const copyCustomField = { ...this.state.customField };

    // We make sure that the new value is different to the previous one
    if (value !== editableValue && value != null)
    {
      // Assign the new values
      copyCustomField.Value = value;
      copyCustomField.PreviousValue = editableValue;
      this.setState({ editableValue: String(value) });

      this.disableEditor();

      // Do not save if autoSaved is disabled
      if (!disableAutoSave)
      {
        const requestSave = {
          api: this.props.apiConfig,
          request: copyCustomField,
        };

        if (
          copyCustomField.CustomFieldValueId === undefined ||
          copyCustomField.CustomFieldValueId === null ||
          copyCustomField.CustomFieldValueId === 0
        )
        {
          CustomFieldsService.savePost(requestSave).then((data: any) =>
          {
            copyCustomField.CustomFieldValueId = data.CustomFieldValueId;

            try
            {
              if (this.props.updateCustomFieldsHistory)
              {
                this.props.updateCustomFieldsHistory(copyCustomField);
              }

              this.setState({ customField: copyCustomField }, () =>
              {
                this.onUpdateCustomField();
              });
            }
            catch (err)
            {
              // Handle error
            }
          });
        }
        else
        {
          CustomFieldsService.save(requestSave).then(() =>
          {
            try
            {
              if (this.props.updateCustomFieldsHistory)
              {
                this.props.updateCustomFieldsHistory(copyCustomField);
              }

              this.setState({ customField: copyCustomField }, () =>
              {
                this.onUpdateCustomField();
              });
            }
            catch (err)
            {
              // Handle error
            }
          });
        }
      }
      else
      {
        // Disable the control
        this.disableEditor();
        this.setState({ customField: copyCustomField }, () =>
        {
          this.onUpdateCustomField();
        });
      }
    }
    else
    {
      // Disable the control
      this.disableEditor();
    }
  }

  enableEditor(e: React.MouseEvent)
  {
    e.preventDefault();

    const { canEdit, value } = this.state;
    const { customField } = this.state;
    if (canEdit && customField.ConversationIsEnable !== false)
    {
      const screenWidth = $('body');
      const widthScreen = screenWidth[0]?.offsetWidth ?? 0;
      const windowX = e.clientX;
      const elemCustField = (e.target as HTMLElement).closest(
        'div.corgee_com_custom-fields-field-A',
      ) as HTMLElement;

      this.setState(
        {
          EditorEnabled: true,
          editableValue: String(value),
          previousWidth: elemCustField?.offsetWidth || 0,
        },
        () =>
        {
          if (155 + windowX > widthScreen && elemCustField)
          {
            elemCustField.className += ' responsiveInfoDetail ';
            elemCustField.style.width = '120px';
          }
          if (this.inputIntegerRef.current)
          {
            this.inputIntegerRef.current.focus();
          }
        },
      );
    }
  }

  disableEditor()
  {
    const elemReset = document.getElementsByClassName('responsiveInfoDetail');
    if (elemReset.length !== 0)
    {
      (elemReset[0] as HTMLElement).style.width = `${this.state.previousWidth}px`;
      (elemReset[0] as HTMLElement).className =
        'corgee_com_custom-fields-field-A _DEL_field-A custom-field-id';
    }
    this.setState({ EditorEnabled: false });
  }

  onUpdateCustomField()
  {
    if (this.props.UpdateCustomFields)
    {
      this.props.UpdateCustomFields(this.state.customField);
    }
  }

  onSaveModal(newValue: number | string, callback?: Function)
  {
    this.setState({
      value: newValue,
    });
    const promise = new Promise<boolean>(resolve =>
    {
      this.save();
      resolve(true);
    });

    promise.then(() =>
    {
      if (callback)
      {
        callback();
      }
    });
  }

  onUpdateModal(newValue: number | string)
  {
    const copyCustomField = { ...this.state.customField };
    copyCustomField.Value = newValue;
    try
    {
      this.setState({
        value: newValue,
      });

      this.setState({ customField: copyCustomField }, () =>
      {
        this.onUpdateCustomField();
      });
    }
    catch (err)
    {
      // Handle error
    }
  }

  onOpenEditHistory()
  {
    const { value } = this.state;
    if (value === 0)
    {
      this.setState({ value: '0' }, () => this.save());
    }

    if (this.props.onOpenEditHistory)
    {
      this.props.onOpenEditHistory(this.props.customField, this.onSaveModal, this.onUpdateModal);
    }
  }

  isInteger(x: string): string
  {
    // Field accepting only numbers and "-"
    const n = x.toString().replace(/(?!-)[^0-9]/g, '');

    // Validation to parse only one "-"
    if (x.includes('-'))
    {
      if (x === '-')
      {
        return x;
      }
      else
      {
        const o = Math.sign(Number(n));
        return o === -1 || o === 1 ? n : '';
      }
    }
    else
    {
      return n;
    }
  }

  render()
  {
    const { EditorEnabled, canEdit, value, customField, canEditR, canEditOwner, isAdmin } =
      this.state;
    const clickOutSideWhiteList = [
      { type: 'class', value: 'button-historial' },
      { type: 'class', value: 'glyphicon-time' },
    ];

    return (
      <div
        key={'cf-' + customField.CustomFieldId}
        className="corgee_com_custom-fields-field-A _DEL_field-A custom-field-id"
      >
        {customField.GroupMultiEditionType === 1 && (
          <i
            className="material-icons several-values enable-help-tooltip"
            title="Not all cards selected have this detail. The detail value will change only on applicable cards."
            data-title="Not all cards selected have this detail. The detail value will change only on applicable cards."
          >
            do_not_disturb_on
          </i>
        )}
        <span className="corgee_com_custom-fields-title _DEL_title">{customField.Name}</span>

        <div className="click-to-edit">
          {!EditorEnabled ? (
            <div
              onClick={e => this.validateOwners(e, customField, isAdmin, canEditOwner)}
              className={canEdit ? 'lbl-editable-input' : 'lbl-non-editable-input'}
            >
              {value !== undefined && value !== ''
                ? value
                : parseInt(String(value)) === 0
                  ? 0
                  : 'Not Set'}
            </div>
          ) : null}

          {EditorEnabled ? (
            <ClickOutSide onClickOutSide={this.save} whiteList={clickOutSideWhiteList}>
              <div className="corgee_com_custom-fields-numeric-integer">
                <div
                  className="ctrl-editable-input"
                  style={{ position: 'absolute', zIndex: 999999 }}
                >
                  <div className="input-group">
                    {canEditR && !!this.props.conversation?.CoreTaskId ? (
                      <span
                        onClick={this.onOpenEditHistory}
                        className="input-group-addon button-historial"
                        title="Edit history"
                      >
                        <i className="material-icons" aria-hidden="true">
                          schedule
                        </i>
                      </span>
                    ) : null}
                    <InputNumber
                      ref={this.inputIntegerRef}
                      step={1}
                      value={this.state.value as number}
                      onChange={(value: string | number | null) => this.handleChange(value ?? '')}
                      autoFocus={true}
                      parser={(x: string | undefined) => this.isInteger(x ?? '')}
                    />
                  </div>
                </div>
              </div>
            </ClickOutSide>
          ) : null}
        </div>
      </div>
    );
  }
}

export default NumericIntegerField;
